<div>
  <svc-app-barcode></svc-app-barcode>
</div>